
import React, { useState, useEffect } from 'react';
import { physicalProps } from '@/services/common';
import { Button, Card, Modal, Input, Row, Col, Select, Spin, message, List } from 'antd';

const Component = (props:any) => {
  const {curInfo}=props;

  return (
      <Row gutter={[20, 20]}>
        <Col span={24}>
          <Card 
          size='small'
          title={<b className='t3'>空间坐标：</b>}
          type='inner'
          style={{marginTop:'1rem'}}
          >
            <Row>
              <Col span={8} style={{textAlign:'center'}}><b className='t2'>x：{curInfo.x}</b></Col>
              <Col span={8} style={{textAlign:'center'}}><b className='t2'>y：{curInfo.y}</b></Col>
              <Col span={8} style={{textAlign:'center'}}><b className='t2'>z：{curInfo.z}</b></Col>
            </Row>
          </Card>
        </Col>
        <Col span={12}>
          <Card size='small' style={{ borderRadius: '5px' }}>
            <List size='small'>
              <List.Item>
                原子序数：<b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.number}</b>
              </List.Item>
              <List.Item>
                元素符号：<b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.symbol}</b>
              </List.Item>
              <List.Item>
                原子量：<b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.MW}</b><span className='unit'>g/mol</span>
              </List.Item>
              <List.Item>
                质子数：<b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.protons}</b>
              </List.Item>
              <List.Item>
                电子数：<b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.electrons}</b>
              </List.Item>
              {/* <List.Item>
                CAS编号：<b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.CAS}</b>
              </List.Item> */}
              <List.Item>
                周期表中的周期：<b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.period}</b>
              </List.Item>
              <List.Item>
                周期表中的组：<b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.group}</b>
              </List.Item>
              <List.Item>
                周期表的块：<b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.block}</b>
              </List.Item>
            </List>
          </Card>
        </Col>
        <Col span={12}>
          <Card size='small' style={{ borderRadius: '5px' }}>
            <List size='small'>
              <List.Item>
                Allred和Rochow电负性：<b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.AReneg}</b>
              </List.Item>
              <List.Item>
                共价半径：<b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.rcov}</b><span className='unit'>Angstrom</span>
              </List.Item>
              <List.Item>
                范德瓦尔斯半径：<b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.rvdw}</b><span className='unit'>Angstrom</span>
              </List.Item>
              <List.Item>
                键的最大价：<b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.maxbonds}</b>
              </List.Item>
              <List.Item>
                包层电负性：<b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.elneg}</b>
              </List.Item>
              <List.Item>
                电离势：<b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.ionization}</b><span className='unit'>eV</span>
              </List.Item>
              <List.Item>
                亲和力：<b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.elaffinity}</b><span className='unit'>eV</span>
              </List.Item>
              <List.Item>
                元素InChI标识符：<b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.InChI}</b>
              </List.Item>

            </List>
          </Card>
        </Col>
        {/* <Col span={8}>
          <Card size='small' style={{ borderRadius: '5px' }}>
            <List size='small'>
              <List.Item>
                化合物InChI的25字符散列：<p><b className='t4' style={{color:'rgb(0, 140, 255)'}}>{curInfo.InChI_key}</b></p>
              </List.Item>
              <List.Item>
                SMILES编码：<b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.smiles}</b>
              </List.Item>
              <List.Item>
                化学品PubChem化合物标识符（CID）：<b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.PubChem}</b>
              </List.Item>
              <List.Item>
                atm和298.15 K下的标准状态：<b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.phase}</b>
              </List.Item>
              <List.Item>
                标准状态下的形成焓：<b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.Hf}</b><span className='unit'>J/mol</span>
              </List.Item>
              <List.Item>
                标准状态下的标准绝对熵（1 bar，298.15 K）：<p><b className='t2' style={{color:'rgb(0, 140, 255)'}}>{curInfo.S0}</b><span className='unit'>J/mol/K</span></p>
              </List.Item>
            </List>
          </Card>
        </Col> */}
      </Row>

  );
};


export default Component;

